module.exports = __webpack_public_path__ + "img/2.f4a3e5aa.jpeg";